import { decode, isTablet } from 'utils/general';
import on from 'dom-event';
import debounce from 'lodash.debounce';

export default {
  props: ['products', 'heading', 'cardIndex'],
  components: {
    'product-card': () => import('../product-card/product-card.vue'),
    'vue-swiper': () => import('../vue-swiper/vue-swiper.vue'),
    'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
  },
  data() {
    return {
      productObjects: [...JSON.parse(decode(this.products))],
    };
  },
  mounted() {},
  methods: {},
  template: `
    <div>
      <div class="get-the-look__products hidden visible-desktop"
           ref="grid">
        <product-card
          v-for="(product, index) in productObjects"
          :key="index"
          :product="product"
          :parent-title="heading"
          additional-classes="get-the-look__product-card"
          list-type="get-the-look-products"
        >
        </product-card>
      </div>

      <div class="get-the-look__products swiper hidden-m hidden-md hidden-l"
           is="vue-swiper"
            :options="{ slidesPerView: 1.7 }"
           ref="carousel">
        <div class="swiper-wrapper">
          <product-card
            v-for="(product, index) in productObjects"
            :key="index"
            :product="product"
            :parent-title="heading"
            additional-classes="get-the-look__product-card swiper-slide"
            list-type="get-the-look-products"
          >
          </product-card>
        </div>
      </div>
    </div>
  `,
};
